export default "__VITE_ASSET__9a5a7d13__"